import { ActionTree } from 'vuex';
import {
  ETemplateUsageAction,
  ETemplateUsageMutation,
  state as defaultState,
} from '@/content-library/template-usage/store/template-usage.constants';
import { ITemplateUsageState } from '@/content-library/template-usage/store/template-usage.types';
import { RootState } from '@/store/store';
import { IDocument } from '@/types/Document';
import { IDocumentResource } from '@/api/resources/types/document-resource';
import { ResourceService } from '@/api/resources/services/resource.service';
import { DocumentService } from '@/api/documents/services/document.service';
import { APIErrorMessages } from '@/api/constants/api-errors.constants';

export const actions: ActionTree<ITemplateUsageState, RootState> = {
  async [ETemplateUsageAction.Load]({ commit, dispatch }, resourceId: string) {
    commit(ETemplateUsageMutation.SetLoaded, false);
    commit(ETemplateUsageMutation.SetLoading, true);
    try {
      const documentResources: IDocumentResource[] = await ResourceService.loadDocumentResources({
        resourceId,
        inTemplate: true,
      });
      const templates: Partial<IDocument>[] = [];
      for (const documentResource of documentResources) {
        try {
          const templateDetails = await DocumentService.loadTemplateResourceDetails(
            documentResource.documentId
          );
          templates.push(templateDetails);
        } catch (e) {
          // Handle case where the template, in which the resource has been used, has been previously deleted
          const isTemplateDeleted = e?.message === APIErrorMessages.NoSuchDocument;
          if (!isTemplateDeleted) {
            throw e;
          }
        }
      }

      dispatch(ETemplateUsageAction.LoadSuccess, templates);
    } catch {
      dispatch(ETemplateUsageAction.LoadFailed);
    }
  },
  [ETemplateUsageAction.LoadSuccess]({ commit }, templates: IDocument[]) {
    commit(ETemplateUsageMutation.SetTemplates, templates);
    commit(ETemplateUsageMutation.SetLoading, false);
    commit(ETemplateUsageMutation.SetLoaded, true);
  },
  [ETemplateUsageAction.LoadFailed]({ commit }) {
    commit(ETemplateUsageMutation.SetLoading, false);
    commit(ETemplateUsageMutation.SetLoaded, false);
  },
  [ETemplateUsageAction.Reset]({ commit }) {
    commit(ETemplateUsageMutation.SetState, { ...defaultState });
  },
};
